import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AutomationList from "./automation-list";
import AutomationTypeHeader from "./automation-type-header";
import dropdown from "./dropdown";
import { mapState } from "vuex";
import { isEqual, uniqWith } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  components: {
    AutomationList,
    AutomationTypeHeader,
    BoardsDropdown: dropdown
  },
  props: {
    trigger: {
      type: Object,
      required: true
    },
    automations: {
      type: Array,
      required: true
    },
    level: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      currentBoard: ""
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("AutomationStore", ["collapseTriggers"])), {}, {
    canBeShared() {
      const triggerArguments = this.trigger["trigger-arguments"];
      return triggerArguments && triggerArguments.some(triggerArg => triggerArg.id === "board");
    },
    defaultBoard() {
      return {
        name: this.$t("boards.filters.allBoards"),
        value: "all-boards"
      };
    },
    colSize() {
      return this.canBeShared ? "col-6" : "col-12";
    },
    existSharedAutomations() {
      return this.automations.some(automation => automation.shared);
    },
    boardsRelated() {
      var _context;
      const automationsSharedByTrigger = _filterInstanceProperty(_context = this.automations).call(_context, automation => automation.shared && automation.trigger === this.trigger.key);
      const boards = _mapInstanceProperty(automationsSharedByTrigger).call(automationsSharedByTrigger, ({
        "trigger-arguments": triggerArg
      }) => {
        return triggerArg.board;
      });
      const boardsWithoutDuplicate = uniqWith(boards, isEqual);
      return [...boardsWithoutDuplicate, this.defaultBoard];
    },
    isCollapsed() {
      return this.collapseTriggers[this.trigger.key];
    },
    typeHeaderTitleProperties() {
      const parser = {
        board: {
          titlePrefix: `${this.$t("automations.prefixes.when")} `,
          subtitlePrefix: `${this.$t("automations.prefixes.triggersWhenever")}: `,
          subtitleSuffix: ""
        },
        application: {
          titlePrefix: "",
          subtitlePrefix: `${this.$t("automations.prefixes.basedOn")}: `,
          subtitleSuffix: ""
        }
      };
      return parser[this.level];
    }
  }),
  beforeMount() {
    this.currentBoard = this.defaultBoard;
  },
  methods: {
    levelIs(level) {
      return this.level === level;
    }
  }
});